"use client";

import Image from "next/image";
import ButtonBlueBorder from "@/app/components/appcomponents/ButtonBlueBorder";
import toast from "react-hot-toast";
import { EXAMPLE_MEMORY_URL, DOUBLE_BENEFIT_TEXT } from "@/app/components/orders/orderConfig";
import { PopupShell, SecondaryButton } from "./parts";

export const CANDLE_OPTIONS = [
  { value: "", label: "Brez animirane svečke" },
  { value: "1y", label: "1-letna spominska svečka – 20 €" },
  { value: "5y", label: "5-letna spominska svečka – 30 €" },
];

const linkClass = "text-[#0A85C2] underline";

/** Step 3: optional animated memorial candle, bought together with the message. */
export default function StepCandle({ form, update, onBack, onSubmit, submitting, onClose }) {
  return (
    <PopupShell
      title="Dodatna opcija - spominska svečka"
      subtitle="Ni nujno; lahko kar preskočite in greste na zadnji korak"
      titleClassName="[@media(min-width:744px)]:pl-[16px] [@media(min-width:744px)]:pt-[32px]"
      figmaDesktop
      panelTopClass="[@media(min-width:744px)]:!mt-[34px]"
      panelPadding="px-[62px] py-[46px]"
      onClose={onClose}
      footer={
        <div className="mt-[44px] flex items-center justify-between gap-4 mobile:mt-4">
          <SecondaryButton onClick={onBack} className="h-[60px] w-[150px] px-8 text-[20px] mobile:h-[56px] mobile:w-auto">
            Nazaj
          </SecondaryButton>
          <div className="w-[250px] mobile:w-[168px]">
            <ButtonBlueBorder
              placeholder={
                <>
                  <span className="mobile:hidden">Zadnji korak</span>
                  <span className="hidden mobile:inline">Naprej</span>
                </>
              }
              onClick={onSubmit}
              loading={submitting}
            />
          </div>
        </div>
      }
    >
      <p className="text-[16px] leading-[24px] text-[#1E2125] mobile:text-[14px] mobile:leading-[21px]">
        Skrbnik spominske strani jo prejme v paketu brez doplačila, drugi jo lahko naročijo.
      </p>

      <div className="mt-6 flex h-[243px] flex-col items-center justify-center rounded-[10px] border border-[#6D778E]/70 px-4 mobile:mt-4 mobile:h-auto mobile:justify-start mobile:py-6">
        <div className="rounded-[10px] bg-white p-[3px] shadow-custom-light-dark-box">
          <Image
            src="/user5.jpeg"
            alt="Animirana spominska svečka"
            width={168}
            height={220}
            className="h-[110px] w-[84px] rounded-[8px] object-cover mobile:h-[104px] mobile:w-[80px]"
          />
        </div>
        <p className="mt-3 text-center text-[16px] leading-[24px] text-[#1E2125] mobile:text-[15px]">
          {form.authorName}
        </p>
      </div>

      <p className="mt-6 text-[16px] leading-[24px] text-[#1E2125] mobile:hidden">
        <a href={EXAMPLE_MEMORY_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>
          Tule
        </a> si lahko ogledate primer na spominski strani.
      </p>
      <p className="mt-2 text-[16px] leading-[24px] text-[#1E2125] mobile:mt-4 mobile:text-[14px] mobile:leading-[21px]">
        Animirana svečka prinaša <span className="hidden mobile:inline">dodatno </span>korist. Več informacij je{" "}
        <button
          type="button"
          onClick={() => toast(DOUBLE_BENEFIT_TEXT, { duration: 9000 })}
          className={linkClass}
        >
          tukaj
        </button>
        .
      </p>

      <label className="mt-6 block">
        <span className="sr-only">Spominska svečka</span>
        <select
          value={form.candle}
          onChange={(e) => update({ candle: e.target.value })}
          className="h-[48px] w-full rounded-[6px] bg-[#F3F2E6] px-4 text-[16px] text-[#6D778E] shadow-custom-dark-to-white focus:outline-none"
        >
          {CANDLE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </PopupShell>
  );
}
